
<nz-back-top [nzTemplate]="tpl" [nzVisibilityHeight]="520" (nzClick)="backTop()">
  <ng-template #tpl>
    <div class="ant-back-top-inner">
      <svg-icon [iconName]="'new/to_top.svg'" class="cursor-pointer"></svg-icon>
      <div class="mt-[-8px]">
        {{"BACK_TOP" | translate}}
      </div>
    </div>
  </ng-template>
</nz-back-top>

<div class="cart bg-darkGrey mx:py-6 sm:py-2 sm:px-2 mx:px-8">
  <div class="mx:hidden sm:block" *ngIf="showTips">
    <div class="bg-error text-base min-h-[48px] flex-v-center justify-between mb-2"
      *ngIf="placeErrorMessage.length>0">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          <div *ngFor="let error of placeErrorMessage; ">{{error.severity=='E'?error.message:''}}</div>
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>

    </div>
    <div class="bg-error text-base min-h-[48px] flex-v-center justify-between mb-2"
      *ngIf="hasErrorMessage || (cartData?.mergeErrorMessages?.length??0)>0">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          <div *ngIf="hasErrorMessage">{{'CART_ERROR_TIPS'|translate}}</div>
          <div *ngFor="let error of cartData?.mergeErrorMessages; ">{{error.severity=='E'?error.message:''}}</div>
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>

    </div>
    <div class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2"
      *ngIf="(cartData?.messages?.length??0)>0">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          <div *ngFor="let message of cartData?.messages; ">{{message.message}}</div>
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>
    </div>
    <div class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2" *ngIf="isRequiredDateShouldBeLater">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          {{'REQUIRED_DATE_SHOULD_BE_LATER'|translate}}
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>
    </div>
    <div class="bg-success text-base h-[48px] flex-v-center justify-between mb-2" *ngIf="needSimulate">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          {{'CART_SIMULATE_TIPS'|translate}}
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>
    </div>
    <div class="bg-success text-base h-[48px] flex-v-center justify-between mb-2" *ngIf="placeOrderEnable">
      <div class="flex items-center">
        <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
        <div>
          {{'CART_PLACE_ORDER_TIPS'|translate}}
        </div>
      </div>
      <svg-icon [iconName]="'new/close.svg'" class="mr-5 cursor-pointer" (click)="showTips=false"></svg-icon>
    </div>
  </div> 


  <div
    class="operation grid gap-x-6 sm:grid-cols-1 md:grid-cols-[1fr_440px] lg:grid-cols-[1fr_300px_440px] xl:grid-cols-[1fr_300px_440px]">
    <!-- export -->
    <div class="self-center  md:w-full sm:order-3 md:order-3 lg:order-1 xl:order-1">
      <div class="grid  gap-4 sm:mt-2  sm:grid-cols-2 md:grid-cols-2 lx:flex lx:flex-wrap">
        <div class="flex-v-center cursor-pointer" (click)="toggleSelectAll()" *ngIf="productList.length>0">
          <svg-icon [iconName]="'new/choosed.svg'" *ngIf="isAllSelected"></svg-icon>
          <svg-icon [iconName]="'new/checkbox.svg'" *ngIf="!isAllSelected"></svg-icon>
          <span class="ml-2 mr-2">{{"CART_SELECT" | translate }}</span>
          <span>({{selectedIds.length}})</span>
        </div>
        <div class="flex-v-center cursor-pointer" [ngClass]="{'pointer-events-none':selectedIds.length==0,'text-greyDisable':selectedIds.length==0,'text-primaryBlue':selectedIds.length>0}"
          (click)="removeFromCart(form)" *ngIf="productList.length>0">
          <svg-icon [iconName]="'new/delete_c.svg'" [isUrl]="false"></svg-icon>
          <span class="ml-1">{{"CART_DEL_SELECT" | translate }}</span>
        </div>
        <div class="flex-v-center cursor-pointer" [ngClass]="{'pointer-events-none':!hasAbnormal,'text-greyDisable':!hasAbnormal,'text-primaryBlue':hasAbnormal}" (click)="removeAllFromCart(true,form)" *ngIf="productList.length>0 && isExpand">
          <svg-icon [iconName]="'new/delete_c.svg'" [isUrl]="false"></svg-icon>
          <span class="ml-1">{{"CART_DEL_ABNORMAL" | translate }}</span>
        </div>
        <div class="flex-v-center cursor-pointer" (click)="exportExcel()" *ngIf="productList.length>0 && isExpand">
          <svg-icon [iconName]="'new/download.svg'" class="text-primaryBlue"></svg-icon>
          <span class="text-primaryBlue ml-1">{{"EXPORT" | translate }}</span>
        </div>
        <div class="flex-v-center cursor-pointer" (click)="showAdd()" *ngIf="isExpand">
          <svg-icon [iconName]="'new/add_blue.svg'"></svg-icon>
          <span class="text-primaryBlue ml-1">{{"HOME_QUICK_ADD" | translate }}</span>
        </div>
        <div class="flex-v-center cursor-pointer text-primaryBlue" [ngClass]="{'pointer-events-none':selectedIds.length==0 || markNonBoschLoading}"
          (click)="markNonBoschPart()" *ngIf="productList.length>0 && isExpand && isOesCountry() && salesOffice=='SOC'">
          <svg-icon [iconName]="'new/label_edit.svg'" [isUrl]="false" class="text-primaryBlue"></svg-icon>
          <span class="ml-1">{{"MARK_NON_BOSCH_PART_NO" | translate }}</span>
        </div>
      </div>
    </div>

    <!-- sort -->
    <div class=" order-1 sm:order-2 md:order-1 lg:order-1 xl:order-2">
      <div class="flex-center sm:mt-2">
        <div class="flex-1 mr-3">
          <nz-select nzDropdownClassName="drop" [ngModel]="sortType" (ngModelChange)="onSortTypeChange($event)"
            class="bosch-select sort-select w-full lx:w-[200px] bg-darkSelectBg" [nzSuffixIcon]="suffixSearch">
            <nz-option *ngFor="let item of sortList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
            </nz-option>
          </nz-select>
          <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
        </div>
        <div>
          <!-- h5 -->
          <div class="lx:hidden sm:block w-[48px] h-[48px] pt-3 cursor-pointer" (click)="expandIcon()">
            <svg-icon [iconName]="'new/compress.svg'" class="cursor-pointer pl-3"></svg-icon>
          </div>
          <div class="sm:hidden md:hidden lg:flex xl:flex bg-white h-[48px]">
            <div class="w-[48px] h-[48px] pt-3 text-center">
              <svg-icon (click)="changeMode('list')" *ngIf="showMode === 'list'" [iconName]="'new/list_blue.svg'"
                class="cursor-pointer"></svg-icon>
              <svg-icon (click)="changeMode('list')" *ngIf="showMode === 'table'" [iconName]="'new/list_grey.svg'"
                class="cursor-pointer"></svg-icon>
            </div>
            <div class="w-[48px] h-[48px] pt-3 text-center">
              <svg-icon (click)="changeMode('table')" *ngIf="showMode === 'list'" [iconName]="'new/table_grey.svg'"
                class="cursor-pointer"></svg-icon>
              <svg-icon (click)="changeMode('table')" *ngIf="showMode === 'table'" [iconName]="'new/table_blue.svg'"
                class="cursor-pointer"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- simulate & place -->
    <div class="order-2 sm:order-1 md:order-2 lg:order-3 xl:order-3">
      <div class="flex flex-col mx:flex-row">
        <div class="bosch-btn mx:w-[212px] sm:w-full sm:mb-2 mx:mr-[16px] cursor-pointer bg-simulateDisabled"
          [ngClass]="{ simulate: needSimulate, 'disabled-simulate': !needSimulate }" appDebounceClick (debounceClick)="handleSimulate()" *ngIf="hasPermission('simulate')">
          <svg-icon *ngIf="needSimulate" [iconName]="'new/calculate_white.svg'" class="mr-2"></svg-icon>
          <svg-icon *ngIf="!needSimulate" [iconName]="'new/calculate_grey.svg'" class="mr-2"></svg-icon>
          {{"CART_SIMULATE"|translate}}
        </div>
        <div class="bosch-btn mx:w-[212px] sm:w-full placeOrder cursor-pointer bg-placeDisabled"
          [ngClass]="{ place: placeOrderEnable, disabled: !placeOrderEnable }" appDebounceClick (debounceClick)="handlePlaceOrderModal()" *ngIf="hasPermission('placeOrder') && isDealerPortal">
          <svg-icon *ngIf="placeOrderEnable" [iconName]="'new/right_blue.svg'" class="mr-2"></svg-icon>
          <svg-icon *ngIf="!placeOrderEnable" [iconName]="'new/arrow-right_grey.svg'" class="mr-2"></svg-icon>
          {{"CART_PLACE_ORDER"|translate}}
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-wrap gap-x-6 mt-6">
    <div class="flex-1 min-w-[250px] bg-white mx:p-4 sm:p-2">
      <!-- cart -->
      <app-cart-list *ngIf="productList.length>0" [placeErrorMessage]="placeErrorMessage" [errorMessage]="cartData?.mergeErrorMessages??[]"
        [class.hidden]="showMode != 'list'" [needSimulate]="needSimulate" [placeOrderEnable]="placeOrderEnable" [messages]="cartData?.messages??[]"
        [hasErrorMessage]="hasErrorMessage" [isRequiredDateShouldBeLater]="isRequiredDateShouldBeLater" [productList]="productList" [reSimulate]="reSimulate"
        (itemSelectionChanged)="handleItemSelectionChange($event)" [form]="form"></app-cart-list>
      <app-cart-table *ngIf="productList.length>0" [placeErrorMessage]="placeErrorMessage" [errorMessage]="cartData?.mergeErrorMessages??[]"
        [class.hidden]="showMode != 'table'" [hasErrorMessage]="hasErrorMessage" [isRequiredDateShouldBeLater]="isRequiredDateShouldBeLater" [productList]="productList" [messages]="cartData?.messages??[]"
        [reSimulate]="reSimulate" (itemSelectionChanged)="handleItemSelectionChange($event)"
        [needSimulate]="needSimulate" [placeOrderEnable]="placeOrderEnable" [form]="form"></app-cart-table>
      <div class="no-data flex-v-center" *ngIf="productList.length==0">
        <img src="assets/no-data.svg" />
        <div class="empty-text">{{"CART_EMPTY"|translate}}</div>
        <div class="quick-add flex-center" (click)="isVisible = true">
          <i></i>
          {{"HOME_QUICK_ADD"|translate}}
        </div>
      </div>
    </div>
    <div class="w-[440px] md:w-full sm:w-full sm:mt-2 md:mt-2">
      <!-- order summary -->
      <div class="cart_content_po_wrap p-4 bg-white">
        <h3 class="font-bold">{{"ORDER_SUMMARY"|translate}}</h3>
        <div class="line my-4"></div>
        <form [formGroup]="form">
          <h3 class="font-bold mb-1.5" *ngIf="country=='/oes' && brandList.length>0 && salesOffice!='SOC'">
            <span class="text-red mr-1 leading-6 h-[24px] inline-block" *ngIf="country=='/oes'">*</span><span>{{"BRAND"|translate}}</span></h3>
          <!-- brand -->
          <nz-select *ngIf="country=='/oes' && brandList.length>0 && salesOffice!='SOC'" formControlName="brand" [nzSuffixIcon]="suffixSearch"
            class="bosch-select w-full mb-4" [nzPlaceHolder]="'BRAND' | translate">
            <nz-option [nzValue]="brand.brandCode" [nzLabel]="brand.brandDesc"
              *ngFor="let brand of brandList"></nz-option>
          </nz-select>
          <!-- price detail -->
          <div class="mb-4">
            <h3 class="mb-1.5 font-bold">{{"CART_TOTAL"|translate}}</h3>
            <div class="bg-darkGrey p-4">
              <p class="flex-between text-base items-center mb-1">
                <span>{{"CART_TOTAL_ITEMS"|translate}}</span><span class="text-greyDisable">{{
                  productList.length }}
                </span>
              </p>
              <p class="flex-between text-base items-center mb-1">
                <span>{{"GROSS_VALUE"|translate}}</span><span class="text-greyDisable">{{!needSimulate?
                  (cartData.totalAmount?.currency || "--") + '&nbsp;' +
                  (cartData.totalAmount.value?(cartData.totalAmount.value| number : "1.2-2"):""):'--' }}
                </span>
              </p>
              <p class="flex-between text-base items-center mb-1">
                <span>{{"NET_VALUE"|translate}}</span><span class="text-greyDisable">{{!needSimulate?
                  (cartData.netValue?.currency || "--") + '&nbsp;' +
                  (cartData.netValue.value?(cartData.netValue.value| number : "1.2-2"):""):'--' }}
                </span>
              </p>
              <p class="flex-between items-center mb-1 text-base " *ngIf="cartData.totalFreight.value">
                <span>{{"TOTAL_FREIGHT"|translate}}</span><span class="text-greyDisable">{{
                  !needSimulate?(cartData.totalFreight?.currency ||
                  "--") + '&nbsp;' + (cartData.totalFreight.value&&!needSimulate?(cartData.totalFreight.value| number :
                  "1.2-2"):""):'--' }}
                </span>
              </p>
              <p class="flex-between text-base items-center mb-1">
                <span>{{"MOV_SURCHARGE"|translate}}</span><span class="text-greyDisable">{{!needSimulate?
                  (cartData.movSurcharge?.currency || "--") + '&nbsp;' +
                  (cartData.movSurcharge?.value?(cartData.movSurcharge.value| number : "1.2-2"):""):'--' }}
                </span>
              </p>
              <p class="flex-between items-center mb-1 text-base ">
                <span>{{"TAX"|translate}}</span><span class="text-greyDisable">{{
                  !needSimulate?(cartData.tax?.currency ||
                  "--") + '&nbsp;' + (cartData.tax.value&&!needSimulate?(cartData.tax.value| number :
                  "1.2-2"):""):'--' }}
                </span>
              </p>
              <p class="flex-between text-base mb-1 items-center " *ngIf="cartData.bonusDiscount?.value">
                <!-- todo -->
                <span class="text-base">{{"PROMOTION"|translate}}</span><span class="text-greyDisable">{{!needSimulate?
                  (cartData.bonusDiscount?.currency || "--") + '&nbsp;'
                  + (cartData.bonusDiscount?.value&&!needSimulate?(cartData.bonusDiscount?.value| number : "1.2-2"):""):'--'}}
                </span>
              </p>
            </div>
          </div>
          <!-- po -->
          <h3 class="font-bold mb-1.5">
            <span class="text-red mr-1 leading-6 h-[24px] inline-block" *ngIf="country=='/oes'">*</span><span>{{"CART_PO"|translate}}</span></h3>
          <div class="mb-4 flex items-center">
            
            <input formControlName="poNumber" nz-input [placeholder]="'CART_PO_PLACEHOLDER' | translate"
              class="bosch_input" />
          </div>
          <h3 class="font-bold mb-1.5">{{"CART_PROCESS_DESC"|translate}}</h3>
          <nz-select formControlName="orderType" [nzSuffixIcon]="suffixSearch" class="bosch-select w-full mb-4">
            <nz-option [nzValue]="orderType" [nzLabel]="getOrderTypeName(orderType)" *ngFor="let orderType of cartData.orderTypeList"></nz-option>
            <!-- <nz-option nzValue="Standard_Sales" [nzLabel]="'CART_STANDARD_ORDER'|translate"></nz-option>
            <nz-option nzValue="Rush_Sales" [nzLabel]="'CART_RUSH_ORDER'|translate"></nz-option> -->
          </nz-select>
          <!-- <p class="font-bold mb-1.5" *ngIf="form.get('orderType')?.value=='Rush_Sales'">
            {{"DISPATCH_TYPE"|translate}}</p>
          <nz-select *ngIf="form.get('orderType')?.value=='Rush_Sales'" formControlName="dispatchType"
            [nzSuffixIcon]="suffixSearch" class="bosch-select w-full mb-4">
            <nz-option nzValue="02" nzLabel="Air"></nz-option>
            <nz-option nzValue="03" nzLabel="Customer Pickup"></nz-option>
            <nz-option nzValue="70" nzLabel="Road"></nz-option>
          </nz-select> -->
          <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
          <p *ngIf="country === '/oes'" class="mb-1.5 font-bold">{{"SHIPMENT_&_DELIVERY"|translate}}</p>
          <div *ngIf="country === '/oes'" class="mb-4">
            <label formControlName="completeDelivery" nz-checkbox>
              <span class="color-black">{{"COMPLETE_DELIVERY"|translate}}</span> {{"SHIPMENT_TIPS"|translate}}
            </label>
          </div>
          <!-- expected date -->
          <p class="mb-1.5 font-bold" *ngIf="form.get('completeDelivery')?.value==true">
            {{"CART_DELIVERY_DATE"|translate}}</p>
          <nz-date-picker *ngIf="form.get('completeDelivery')?.value==true" formControlName="deliveryDate"
            [nzSuffixIcon]="suffixDate" nzPlaceHolder="'CART_DELIVERY_DATE|translate" [nzAllowClear]="false"
            class="bosch-date-picker calender-picker w-full mb-4" nzFormat="yyyy-MM-dd" [nzDisabledDate]="disabledDate"></nz-date-picker>
          <ng-template #suffixDate> <svg-icon [isUrl]="false" [iconName]="'new/calendar.svg'"
              class="text-black"></svg-icon></ng-template>
          <!-- shipping address -->
          <div>
            <div style="display: flex;">
              <div class="font-bold mb-1.5">{{"CART_SHIPPING_ADDRESS"|translate}}</div>
              <div class="font-bold mb-1.5 cursor-pointer" style="margin-left: auto; display: flex; color: #007BC0"
                (click)="isAddressVisible=true">
                <i nz-icon nzType="edit" nzTheme="outline" style="width: 18px; position: relative; top: 5px;"></i>
                {{"CART_EDIT_SHIPPING_ADDRESS"|translate}}
              </div>
            </div>
            <div class="shipping_address_content bg-darkGrey" [ngClass]="{ 'address-error': addressError }">
              <div>
                <p class="truncate" [attr.title]="shippingAddress?.customerName">{{ shippingAddress?.customerName }}</p>
                <p class="truncate" [attr.title]="shippingAddress?.street">{{ shippingAddress?.street }}
                </p>
                <p>{{ shippingAddress?.postalCode }} {{ shippingAddress?.city }}</p>
                <p>{{ shippingAddress?.country }} {{ shippingAddress?.region }}</p>
                <p>{{ shippingAddress?.mobilePhone }}</p>
                <p>{{ shippingAddress?.customerCode }}</p>
              </div>
            </div>
            <div class="error-address-tips flex-v-center h-[40px] mt-1" *ngIf="addressError">
              <svg-icon [iconName]="'new/info.svg'" class="mr-4"></svg-icon>
              {{"CART_ADDRESS_ERROR"|translate}}
            </div>
          </div>
          <!-- Shipment Dimensions-->
          <div class="font-bold mt-4 mb-1.5" *ngIf="cartData.shipmentDimension">
            {{"CART_DIMENSIONS"|translate}}
          </div>
          <div class="shipping_address_content bg-darkGrey" *ngIf="cartData.shipmentDimension">
            <p class="flex-between">
              <span>{{"CART_VOLUME"|translate}}</span><span>{{ cartData.shipmentDimension?.totalVolume }}
                {{ cartData.shipmentDimension?.unitOfVolume }}</span>
            </p>
            <p class="flex-between">
              <span> {{"CART_WEIGHT"|translate}}</span><span>{{
                cartData.shipmentDimension?.totalWeight }}
                {{ cartData.shipmentDimension?.unitOfWeight }}</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--place order modal -->
  <nz-modal [(nzVisible)]="isPlaceVisible" [nzTitle]="modalTitle" [nzWidth]="'auto'" nzCentered [nzMaskClosable]="false"
    (nzOnCancel)="isPlaceVisible = false" [nzClosable]="false" [nzWrapClassName]="'place-order'">
    <ng-template #modalTitle>
      <div class="flex justify-between">
        <span class="font-bold text-base">{{"CART_PLACE_ORDER"|translate}}</span>
        <svg-icon [iconName]="'new/close.svg'" class="cursor-pointer fr" (click)="isPlaceVisible = false"></svg-icon>
      </div>
      
    </ng-template>
    <div *nzModalContent class="sm:w-full mx:w-[680px] text-base">
      <!-- PRICE DETAIL -->
      <div class="mt-4 font-bold text-base">{{"CART_TOTAL"|translate}}</div>
      <div class="bg-darkGrey p-4 mt-1.5">
        <p class="flex-between text-base items-center mb-1">
          <span>{{"CART_TOTAL_ITEMS"|translate}}</span><span class="text-greyDisable">{{
            cartData.list.length }}
          </span>
        </p>
        <p class="flex-between text-base items-center mb-1">
          <span>{{"GROSS_VALUE"|translate}}</span><span class="text-greyDisable">{{ cartData.totalAmount.currency }}
            {{ cartData.totalAmount.value | number : "1.2-2" }}
          </span>
        </p>
        <p class="flex-between text-base items-center mb-1">
          <span>{{"NET_VALUE"|translate}}</span><span class="text-greyDisable">{{ cartData.netValue.currency }}
            {{ cartData.netValue.value | number : "1.2-2" }}
          </span>
        </p>
        <p class="flex-between text-base items-center mb-1" *ngIf="cartData.totalFreight.value">
          <span>{{"TOTAL_FREIGHT"|translate}}</span><span class="text-greyDisable">{{ cartData.totalFreight.currency }}
            {{ cartData.totalFreight.value | number : "1.2-2" }}
          </span>
        </p>
        <p class="flex-between text-base items-center mb-1" *ngIf="cartData.movSurcharge.value">
          <span>{{"MOV_SURCHARGE"|translate}}</span><span class="text-greyDisable">{{ cartData.movSurcharge.currency }}
            {{ cartData.movSurcharge.value | number : "1.2-2" }}
          </span>
        </p>
        <p class="flex-between items-center mb-1 text-base ">
          <span>{{"TAX"|translate}}</span><span class="text-greyDisable">{{ cartData.tax.currency }}
            {{ cartData.tax.value | number : "1.2-2" }}
          </span>
        </p>
        <p class="flex-between text-base mb-1 items-center " *ngIf="cartData.bonusDiscount?.value">
          <span class="text-base">{{"PROMOTION"|translate}}</span><span class="text-greyDisable">{{!needSimulate?
            (cartData.bonusDiscount?.currency || "--") + '&nbsp;'
            + (cartData.bonusDiscount?.value?(cartData.bonusDiscount?.value| number : "1.2-2"):""):'--'}}
          </span>
        </p>
      </div>
      <!-- PO Number -->
      <div class="mt-4 font-bold text-base">{{"CART_PO"|translate}}</div>
      <div class="px-4 py-3 bg-darkGrey mt-1.5">
        <div class="flex-between">
          <span>{{ form.value.poNumber }} </span>
        </div>
      </div>
      <!-- PROCESS -->
      <div class="mt-4 font-bold text-base">{{"CART_PROCESS"|translate}}</div>
      <div class="px-4 py-3 bg-darkGrey mt-1.5">
        <div class="flex-between">
          <span>{{ getOrderTypeName(form.value.orderType) }} </span>
        </div>
      </div>
      <!-- SHIPPING ADDRESS -->
      <div class="mt-4 font-bold text-base">{{"CART_SHIPPING"|translate}}</div>
      <div class="bg-darkGrey p-4 mt-1.5">
        <p class="truncate" [attr.title]="shippingAddress?.customerName">{{ shippingAddress?.customerName }}</p>
        <p class="truncate" [attr.title]="shippingAddress?.street">{{ shippingAddress?.street }}
        </p>
        <p>{{ shippingAddress?.postalCode }} {{ shippingAddress?.city }}</p>
        <p>{{ shippingAddress?.country }} {{ shippingAddress?.region }}</p>
        <p>{{ shippingAddress?.mobilePhone }}</p>
        <p>{{ shippingAddress?.customerCode }}</p>
      </div>
      <!-- SHIPPING DIMENSIONS -->
      <div class="mt-4 font-bold text-base">{{"CART_DIMENSIONS"|translate}}</div>
      <div class="bg-darkGrey p-4 mt-1.5">
        <div class="flex-between">
          <span>{{"CART_VOLUME"|translate}}</span>
          <span class="text-greyDisable">{{ cartData.shipmentDimension?.totalVolume }}
            {{ cartData.shipmentDimension?.unitOfVolume }}</span>
        </div>
        <div class="flex-between">
          <span>{{"CART_WEIGHT"|translate}}</span>
          <span class="text-greyDisable">{{ cartData.shipmentDimension?.totalWeight }}
            {{ cartData.shipmentDimension?.unitOfWeight }}</span>
        </div>
      </div>
      <div class="sm:block mx:flex mt-4 justify-between">
        <div class="flex">
          <svg-icon (click)="toggleAgree()" [iconName]="'new/choosed.svg'" *ngIf="isAgree"></svg-icon>
          <svg-icon (click)="toggleAgree()" [iconName]="'new/checkbox.svg'" *ngIf="!isAgree"></svg-icon>
          <label class="ml-2.5">
            {{"CART_AGREE"|translate}}
            <span class="color-red agree cursor-pointer" (click)="goTerms()">{{"CART_TERMS"|translate}}</span>
            <span class="tag-new">新</span>
          </label>
          <!-- <label class="ml-1">
            <span class="bg-red text-[#fff] inline-block min-w-[22px] h-[22px] text-center text-[14px] rounded px-1">{{"NEW"|translate}}</span>
          </label> -->
        </div>
        <div class="text-base font-bold sm:pl-8">
          <span>{{"TOTAL"|translate}}</span><span class="text-primaryBlue ml-2.5">{{
            cartData.totalAmount.currency }}
            {{ cartData.totalAmount.value | number : "1.2-2" }}</span>
        </div>
      </div>
    </div>
    <div *nzModalFooter class="flex-h-end">
      <div class="primary-small-btn sm:w-[156px]" appDebounceClick (debounceClick)="checkStatusAndPlaceOrder()">{{"CART_PLACE_ORDER"|translate}}</div>
      <div class="default-small-btn ml-4 sm:w-[156px]" (click)="isPlaceVisible = false">{{"CANCEL"|translate}}</div>
    </div>
  </nz-modal>
  <!--quick add -->
  <nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitleContent" [nzWidth]="'auto'" [nzContent]="modalContent"
    [nzFooter]="null" nzCentered [nzClosable]="false" [nzClassName]="'myModal'">
    <ng-template #modalTitleContent>
      <div class="flex-between modal-title">
        <span>{{"HOME_QUICK_ADD"|translate}}</span>
        <svg-icon [iconName]="'new/close.svg'" class="mr-3 cursor-pointer fr" (click)="handleClose()"></svg-icon>
      </div>
    </ng-template>

    <ng-template #modalContent>
      <app-quick-add [isModal]="true" (closeModal)="closeModal()"></app-quick-add>
    </ng-template>
  </nz-modal>
  <!--choose address-->
  <nz-modal [(nzVisible)]="isAddressVisible" [nzTitle]="addressTitleContent" [nzContent]="addressContent"
    [nzFooter]="null" nzCentered [nzClosable]="false" nzClassName="my-address">
    <ng-template #addressTitleContent>
      <div class="flex-between modal-title">
        <span>{{"CART_CHOOSE_ADDRESS"|translate}}</span>
        <svg-icon [iconName]="'new/close.svg'" class="mr-3 cursor-pointer fr" (click)="isAddressVisible = false"></svg-icon>
      </div>
    </ng-template>

    <ng-template #addressContent>
      <cart-address [addressList]="addressList" (handleCloseAddress)="handleCloseAddress()"
      (addressSelected)="handleAddressSelected($event)" ></cart-address>
    </ng-template>
  </nz-modal>

  <!--simulate loading-->
  <nz-modal [(nzVisible)]="simulateLoading" [nzTitle]="" [nzContent]="simulateContent" [nzWidth]="convertPxToRem(736)"
    [nzFooter]="null" nzCentered [nzClosable]="false">

    <ng-template #simulateContent>
      <div class="simulate_wrap">
        <div class="flex-center">
          <svg-icon [iconName]="'loading.svg'" class="rotate-image" [size]="50"></svg-icon>
        </div>
        <div class="title mt12">
          {{"SIMULATE_TIPS"|translate}}
        </div>
        <div class="desc mt12">
          {{"SETTING_UP_TIPS"|translate}}
        </div>
        <div class="loading-bar-small mt12"></div>
        <div class="desc mt12">
          {{"WAIT_TIPS"|translate}}
        </div>
        <div class="flex-center mt12">
          <div class="default-small-btn btn" (click)="cancelSimulate()"><svg-icon [isUrl]="false"
              [iconName]="'close.svg'" class="mr6 leading" [size]="16"></svg-icon>{{"CANCEL"|translate}}</div>
        </div>
      </div>
    </ng-template>
  </nz-modal>

  <!--placeorder loading-->
  <nz-modal [(nzVisible)]="placeLoading" [nzTitle]="" [nzContent]="placeContent" [nzWidth]="convertPxToRem(736)"
    [nzFooter]="null" nzCentered [nzClosable]="false">

    <ng-template #placeContent>
      <div class="simulate_wrap">
        <div class="flex-center">
          <svg-icon [iconName]="'loading.svg'" class="rotate-image" [size]="50"></svg-icon>
        </div>
        <div class="title mt12">
          {{"ORDER_CREATION_PROCESSING"|translate}}
        </div>
        <div class="desc mt12">
          {{"ORDER_CREATION_PROCESSING_TIME"|translate}}
        </div>
        <div class="loading-bar-small mt12"></div>
        <div class="desc mt12">
          {{"UNTIL_CART_VERIFIED"|translate}}
        </div>
        <!-- <div class="flex-center mt12">
          <div class="default-small-btn btn" (click)="cancelPlaceOrder()"><svg-icon [isUrl]="false"
              [iconName]="'close.svg'" class="mr6 leading" [size]="16"></svg-icon> {{"CANCEL"|translate}}</div>
        </div> -->
      </div>
    </ng-template>
  </nz-modal>
